import { createGlobalStyle } from "styled-components"
import { BASIC } from "shared/model/useThemeCookie"

const GlobalStyle = createGlobalStyle`

    /* NOTE: 모든 Container는 width 100% / height fit-content */
    /* NOTE: 모든 Element는 width fit-content / height fit-content */

    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    h1, h2, h3, h4, h5, h6, p, span, button {
        color: ${({ theme }) => theme.color?.type === BASIC ? theme.color?.basic?.font : theme.color?.gradation?.font};
    }
    
    html, body , header, nav, aside, main, section, article, footer, div {
        width: 100%;
        font-size: 16px;
        font-weight: 400;
    }

    h1, h2, h3, h4, h5, h6, p, span {
        width: fit-content;
        min-height: 0;
        font-size: 16px;
        font-weight: 400;
        white-space: pre-wrap;
        word-break: break-all;
    }

    a {
        width: fit-content;
        text-decoration: none;
        cursor: pointer;
    }

    textarea, input {
        border: none;
        outline: none;
        resize: none;
    }

    button {
        width: fit-content;
        cursor: pointer;
        background-color: #00000000;
        border: none;
        outline: none;
        white-space: nowrap;
    }

    table {
        border-collapse: collapse;
    }

    select {
        border: none;
        outline: none;
        -o-appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
`

export default GlobalStyle